import { TaskStatus } from 'models';

export const getInvoiceStatus = (status: TaskStatus) => {
  if (status === 'INVOICED') {
    return 'PENDING';
  } else return status;
};
